var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import Loading from "@irati/ui/src/Loading";
import { payByCard } from "@irati/payments/services/Payments";
import cookieChecker from "@irati/payments/services/3rdPartyCookies";
import { hangPromise } from "@irati/utils/promise";
import { StyledIframe } from "@irati-web/perks/src/containers/PaymentOrder/styles/StyledIframe";
var PaymentForm = /** @class */ (function (_super) {
    __extends(PaymentForm, _super);
    function PaymentForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            iframeUrl: undefined,
            load: hangPromise()
        };
        _this.iframeMessageReceived = function (event) {
            try {
                var data = JSON.parse(event.data);
                var onComplete = _this.props.onComplete;
                onComplete(data);
            }
            catch (err) {
                console.log(err);
                // No-op if wrong message has been received from iFrame
            }
        };
        return _this;
    }
    PaymentForm.prototype.componentDidMount = function () {
        window.addEventListener("message", this.iframeMessageReceived, false);
        this.setState({
            load: this.getPaymentIFrame(this.props.amount, this.props.paymentOrder)
        });
    };
    PaymentForm.prototype.componentWillUnmount = function () {
        window.removeEventListener("message", this.iframeMessageReceived);
    };
    PaymentForm.prototype.getPaymentIFrame = function (amountToPay, paymentOrder) {
        var _this = this;
        return cookieChecker.are3rdPartyCookiesEnabled().then(function (are3rdPartyCookiesAllowed) {
            var payDetails = { amount: amountToPay, enableSaveCardOption: true };
            if (!are3rdPartyCookiesAllowed) {
                payDetails.resUrl = _this.props.redirectReturnUrl;
            }
            return payByCard(paymentOrder, payDetails).then(function (_a) {
                var details = _a.details;
                if (are3rdPartyCookiesAllowed) {
                    _this.setState({
                        iframeUrl: details.url,
                        load: null
                    });
                }
                else {
                    window.location = details.url;
                    return hangPromise();
                }
            });
        });
    };
    PaymentForm.prototype.render = function () {
        var _a = this.state, iframeUrl = _a.iframeUrl, load = _a.load;
        return (React.createElement(Loading, { load: load },
            React.createElement(StyledIframe, { frameBorder: 0, name: "Payment", src: iframeUrl, title: "Payment" })));
    };
    return PaymentForm;
}(Component));
export default PaymentForm;
